import React from 'react';
import { useTranslation } from 'react-i18next';
import Modal from './Modal';

interface Props {
  open: boolean;
  skillName: string;
  onApplyFirst: () => void;
  onProceedAnyway: () => void;
  onClose: () => void;
  loading?: boolean;
}

const LanguageRewriteWarningDialog: React.FC<Props> = ({
  open,
  skillName,
  onApplyFirst,
  onProceedAnyway,
  onClose,
  loading = false,
}) => {
  const { t } = useTranslation('common');

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={t('langRewriteWarning.title')}
      width="440px"
      footer={
        <>
          <button
            type="button"
            className="btn btn-secondary"
            onClick={onClose}
            disabled={loading}
          >
            {t('cancel')}
          </button>
          <button
            type="button"
            className="btn btn-ghost"
            onClick={onProceedAnyway}
            disabled={loading}
          >
            {t('langRewriteWarning.proceedAnyway')}
          </button>
          <button
            type="button"
            className="btn btn-primary"
            onClick={onApplyFirst}
            disabled={loading}
          >
            {loading && <span className="loading-spinner" />}
            {t('langRewriteWarning.handleLanguageFirst')}
          </button>
        </>
      }
    >
      <div style={{ fontSize: '0.9rem', color: 'var(--text-2)', lineHeight: 1.6 }}
        dangerouslySetInnerHTML={{
          __html: t('langRewriteWarning.message', { skillName }).replace(
            `${skillName}`,
            `<strong>${skillName}</strong>`
          )
        }}
      />
    </Modal>
  );
};

export default LanguageRewriteWarningDialog;
